import request from '@/utils/request'

const platform = localStorage.getItem('platform')

export function getAdmins() {
    return request.get(`/${platform}/open/admins`)
}

export function getChannels(data) {
    return request.get(`/${platform}/open/channels`, data)
}

export function getSpreads(data) {
    return request.get(`/${platform}/open/spreads`, data)
}

export function getWorkers(data) {
    return request.get(`/${platform}/open/workers`, data)
}

export function getCorporations(data) {
    return request.get(`/${platform}/open/corporations`, data)
}

export function getMediaAccounts(data) {
    return request.get(`/${platform}/open/media_accounts`, data)
}

export function getPlatforms(data) {
    return request.get(`/${platform}/open/platforms`, data)
}

export function getRechargeTemplates(data) {
    return request.get(`/${platform}/open/recharge_templates`, data)
}

export function getVideos(data) {
    return request.get(`/${platform}/open/videos`, data)
}

export function addVideo(data) {
    return request.post(`/${platform}/open/add_video`, data)
}

export function adCallbackConfigs(data) {
    return request.get(`/${platform}/open/ad_callback_configs`, data)
}

export function getTeams(data) {
    return request.get(`/${platform}/open/teams`, data)
}

export function getProducts(data) {
    return request.get(`/${platform}/open/products`, data)
}

export function getProductDetails(data) {
    return request.get(`/${platform}/open/product_details`, data)
}

export function getAwemes(data) {
    return request.get(`/${platform}/open/awemes`, data)
}

// 获取全域创编可用抖音号列表
export function getUniAwemes(data) {
    return request.get(`/${platform}/open/uni_awemes`, data)
}

export function getSeries(data) {
    return request.get(`/${platform}/open/series`, data)
}

export function getAdvertiserExts(data) {
    return request.get(`/${platform}/open/advertiser_ext`, data)
}

export function getMediaVideos(data) {
    return request.get(`/${platform}/open/media_videos`, data)
}

// 获取账户可用的组织视频列表（EBP 组织素材，仅巨量）
export function getOrgVideos(data) {
    return request.get(`/${platform}/open/org_videos`, data)
}

export function getMediaVideoCovers(data) {
    return request.get(`/${platform}/open/media_video_covers`, data)
}

export function getTitleGroups(data) {
    return request.get(`/${platform}/open/title_groups`, data)
}

export function getMaterialUploaders(data) {
    return request.get(`/${platform}/open/local_material_uploaders`, data)
}

export function getOssUploadUrl(data) {
    return request.post(`/${platform}/open/get_oss_upload_url`, data)
}

export function uploadReport(postData) {
    return request.post(`/${platform}/open/upload_report`, postData)
}

// 分片上传：初始化（复用 getOssUploadUrl，传 upload_type=chunk）
export function chunkUploadInit(data) {
    return request.post(`/${platform}/open/get_oss_upload_url`, data)
}

// 分片上传：上传单个分片（直传大带宽 Hyperf 服务）
export function chunkUploadSlice(uploadBase, chunkData, params) {
    const queryString = new URLSearchParams(params).toString()
    return fetch(`${uploadBase}/upload?${queryString}`, {
        method: 'PUT',
        body: chunkData,
        headers: { 'Content-Type': 'application/octet-stream' },
    }).then(res => res.json())
}

// 分片上传：合并完成（直传大带宽 Hyperf 服务）
export function chunkUploadComplete(uploadBase, params) {
    const queryString = new URLSearchParams(params).toString()
    return fetch(`${uploadBase}/complete?${queryString}`, {
        method: 'POST',
    }).then(res => res.json())
}

export function kuaishouUploadReport(postData) {
    return request.post(`/${platform}/open/kuaishou_upload_report`, postData)
}

export function uploadKuaishouAdvertiser(postData) {
    return request.post(`/${platform}/open/upload_kuaishou_advertiser`, postData)
}

export function getBdAdvertiserExts(data) {
    return request.get(`/${platform}/open/bd_advertiser_ext`, data)
}

//获取定向包
export function getBdAtpFeeds(data) {
    return request.get(`/${platform}/open/bd_atp_feeds`, data)
}

//获取百度落地页
export function getBdPages(data) {
    return request.get(`/${platform}/open/bd_get_pages`, data)
}

export function getAdvertisers(data) {
    return request.get(`/${platform}/open/advertisers`, data)
}

export function getMaterialTags(data) {
    return request.get(`/${platform}/open/material_tags`, data)
}

export function getPlatformTypes(data) {
    return request.get(`/${platform}/open/platform_types`, data)
}

export function getKvData(data) {
    return request.get(`/${platform}/open/get_kv_data`, data)
}

export function getPromoteRules(data) {
    return request.get(`/${platform}/open/get_promote_rules`, data)
}

export function getAdvertiserOrganizes(data) {
    return request.get(`/${platform}/open/get_advertiser_organizes`, data)
}

export function getAdvertisers2(data) {
    let url = `/${platform}/open/get_advertisers`
    return request.get(url, data)
}

export function syncAdvertiserName(data) {
    const method = 'post'
    const url = `/${platform}/open/sync_advertiser_name`
    return request[method](url, data)
}

export function getKuaishouCampaigns(data) {
    return request.get(`/${platform}/open/get_kuaishou_campaigns`, data)
}

export function getDpaCategory(data) {
    return request.get(`/${platform}/open/get_dpa_category`, data)
}

export function createProduct(data) {
    const method = 'post'
    const url = `/${platform}/open/create_product`
    return request[method](url, data)
}

export function getMediaCorporationAdvertiser(data) {
    return request.get(`/${platform}/open/get_media_corporation_advertiser`, data)
}

// 铺户+计划：根据应用类型数组查询媒体主体列表（查 media_corporation_settings 表）
export function getFullPipelineMediaCorporations(data) {
    return request.get(`/${platform}/open/get_full_pipeline_media_corporations`, data)
}

export function getAdvertiserTask(data) {
    return request.get(`/${platform}/open/get_advertiser_task`, data)
}

export function updateAdvertiserTask(data) {
    const method = 'post'
    const url = `/${platform}/open/update_advertiser_task`
    return request[method](url, data)
}

export function retryAdvertiserChildrenTask(data) {
    const method = 'post'
    const url = `/${platform}/open/update_advertiser_children_task`
    return request[method](url, data)
}


export function getProductConfigs(data) {
    return request.get(`/${platform}/open/get_product_configs`, data)
}

export function getJuliangEmails(data) {
    return request.get(`/${platform}/open/get_juliang_emails`, data)
}

// 快手可选登录邮箱（来源【邮箱配置】media=快手），用于广告主绑定邮箱时下拉选择
export function getKuaishouEmails(data) {
    return request.get(`/${platform}/open/get_kuaishou_emails`, data)
}

export function getAdvertiserInfo(data) {
    return request.get(`/${platform}/open/get_advertiser_info`, data)
}

export function getPtFenxiaos(data) {
    return request.get(`/${platform}/open/get_pt_fenxiaos`, data)
}

export function getUniLocalFenxiaoLinks(data) {
    return request.get(`/${platform}/open/uni_local_fenxiao_links`, data)
}

export function syncUniChangduLinks(data) {
    return request.post(`/${platform}/open/uni_sync_changdu_links`, data)
}

export function getUniFenxiaoLinkInfo(data) {
    return request.get(`/${platform}/open/uni_fenxiao_link_info`, data)
}

export function getDiskCapacity(data) {
    return request.get(`/${platform}/open/get_disk_capacity`, data)
}

export function verifyBindWorker(ids, bind_worker) {
    const method = 'get'
    const url = `/${platform}/open/verify_bind_worker`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids, bind_worker:bind_worker})
}

export function taskProgress(data) {
    return request.get(`/${platform}/open/task_progress`, data)
}

export function getTeamSettings(data) {
    return request.get(`/${platform}/open/get_team_settings`, data)
}

export function getCustomParams(data) {
    return request.get(`/${platform}/open/get_custom_params`, data)
}

export function syncMaterial(data) {
    return request.post(`/${platform}/open/sync_material`, data)
}

export function getDeveloperAccounts(data) {
    return request.get(`/${platform}/open/get_developer_accounts`, data)
}

export function getNewAdmins() {
    return request.get(`/${platform}/open/get_admins`)
}

export function getEpisodes(data) {
    return request.post(`/${platform}/open/episodes`, data)
}

export function getPayModeType(data) {
    return request.post(`/${platform}/open/pay_model_type`, data)
}

export function getPayTemplates(data) {
    return request.post(`/${platform}/open/pay_templates`, data)
}

export function getAdminTeams(data) {
    return request.get(`/${platform}/open/get_admin_teams`, data)
}

export function getAllTeams(data) {
    return request.get(`/${platform}/open/get_teams`, data)
}

export function verifyMediaCorporations(data) {
    return request.get(`/${platform}/open/verify_media_corporations`, data)
}

export function clearMediaCorporations(data) {
    return request.get(`/${platform}/open/clear_media_corporations`, data)
}

export function getPushSourceAdvertisers(data) {
    return request.post(`/${platform}/open/push_source_advertisers`, data)
}

export function getPushRecordCountByName(data) {
    return request.get(`/${platform}/open/push_record_count_by_name`, data)
}

// 角色列表（供管理员列表/新建管理员使用，不依赖角色管理权限）
export function getRoles(data) {
    return request.get(`/${platform}/open/get_roles`, data)
}